module.exports = __webpack_public_path__ + "img/1650769350039.d7fc2d3c.jpeg";